import $ from 'jquery'; // eslint-disable-line
import GoogleMapsApiLoader from 'google-maps-api-loader';
import DistributorFinderView from './distributor-finder';

const distributorFinder = window.distributorFinder;
distributorFinder.GoogleMapsApiLoader = GoogleMapsApiLoader({
	apiKey: DF.googleMapsAPIKey,
	version: 3,
}).then((googleApi) => {
	distributorFinder.googleApi = googleApi;
});

const excludeForms = [Number(DF.gatewayFormId), Number(DF.filterFormId)];

// DF is a localized object.

function maybeSetOrRemoveSavedFields() {
	const savedFields = JSON.parse(window.localStorage.getItem('vtcGatewayFields')) || [];
	const createdDate = savedFields.find(field => field.name === 'vtcGatewayFieldsCreatedDate');
	const todayDate = new Date();
	if (!createdDate) {
		const todayPlus30 = new Date();
		todayPlus30.setDate(todayPlus30.getDate() + 30); // Set now + 30 days as the new date.
		savedFields.push({name: 'vtcGatewayFieldsCreatedDate', value: todayPlus30.getTime()});
		window.localStorage.setItem('vtcGatewayFields', JSON.stringify(savedFields));
	} else if (createdDate && createdDate.value < todayDate.getTime()) {
		window.localStorage.removeItem('vtcGatewayFields');
	}
}

maybeSetOrRemoveSavedFields();

$(document).on('gform_post_render', (event, formId) => {
	if (formId === Number(DF.gatewayFormId)) {
		const $form = $(`#gform_${formId}`);
		const savedFields = JSON.parse(window.localStorage.getItem('vtcGatewayFields')) || [];

		// Add events to listen for changes.
		$(document).on('change', `#gform_${formId} .zip_city_field input`, (changeEvent) => {
			distributorFinder.zipCity = $(changeEvent.currentTarget).val();
			// Make sure we get all the data we need.
			distributorFinder.handleZipCityChange();
		});
		$(document).on('change', `#gform_${formId} .application_field select`, (changeEvent) => {
			distributorFinder.application = $(changeEvent.currentTarget).find(':selected').val();
		});

		// Persistent data.
		$(document).on('change', `#gform_${formId} input, #gform_${formId} select`, (changeEvent) => {
			const $el = $(changeEvent.currentTarget);
			const name = $el.prop('name');
			const tagName = $el.prop('tagName');
			const savedField = savedFields.find(field => field.name === name);
			let value = $el.val();
			if (tagName === 'SELECT') {
				value = $(changeEvent.currentTarget).find(':selected').val();
			}
			if (!savedField) {
				maybeSetOrRemoveSavedFields();
				savedFields.push({name, value});
			} else {
				savedField.value = value;
			}
			window.localStorage.setItem('vtcGatewayFields', JSON.stringify(savedFields));
		});
		// If we have saved data, populate the form.
		if (savedFields.length) {
			$form.find('input, select').each((index, el) => {
				const name = $(el).prop('name');
				const formField = savedFields.find(field => field.name === name);
				if (formField) {
					$(el).val(formField.value).trigger('change');
				}
			});

			// Disable "Remove saved form data" for distributor finder form
			// As per client request in ticket #19850
			if (formId && !excludeForms.includes(formId)) {
				$form.find('.gform_footer').append(`<a class="js-df-remove-saved-fields df-remove-saved-fields">${DF.i18n.RemoveSavedData}</a>`);
			}

			$('body').on('click', '.js-df-remove-saved-fields', (e) => {
				e.preventDefault();
				// Remove the stored data.
				window.localStorage.removeItem('vtcGatewayFields');
				// Reload the page as response.
				location.reload();
			});
		}

		// First let's store the saved data.
		distributorFinder.zipCity = $form.find('.zip_city_field input').val();
		distributorFinder.application = $form.find('.application_field select').find(':selected').val();
	}

	if (
		formId && excludeForms.includes(formId)
	) {
		$(`#gform_${formId} .zip_city_field .ginput_container`).append($('#df-search-use-location-template').html());
	}
});

$(document).on('gform_confirmation_loaded', (event, formId) => {
	if (typeof DF === 'undefined' || formId !== Number(DF.gatewayFormId)) {
		return;
	}

	/**
	 * The DF form BB row content.
	 */
	const rowContent = $('.df-gateway-form').parents('.fl-row-content-wrap');
	if (rowContent.length) {
		rowContent.empty();
		const distributorFinderView = new DistributorFinderView();
		rowContent.html(distributorFinderView.render().el);

		const $form = $(`#gform_${DF.filterFormId}`);
		// Populate the results filter form.
		$form.find('.zip_city_field input').val(distributorFinder.zipCity);
		$form.find('.application_field select').val(distributorFinder.application);
	}
});
